// libs
import { useQuery } from '@apollo/client/react'
// graphql
import { CHART_TEMPLATE_FIELDS_QUERY } from 'graphql/chart/queries'
// types
import { IField, IRiskTemplate } from 'types/graphql'

// The fields of a risk template: what a chart groups by and sums, and how its keys are named
export const useTemplateFields = (riskTemplateId?: string | null) => {
  const { data, loading } = useQuery<{ riskTemplates: { data: IRiskTemplate[] } }>(CHART_TEMPLATE_FIELDS_QUERY, {
    variables: { filter: { ids: [riskTemplateId] } },
    skip: !riskTemplateId
  })

  const fields: IField[] = data?.riskTemplates?.data?.[0]?.fields || []

  return { fields, loading }
}
